import React from 'react';
export function Footer() {
  return <footer className="bg-tennis-dark text-gray-400 py-12 border-t border-white/10" data-id="element-111">
      <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-112">
        <div className="mb-8" data-id="element-113">
          <div className="text-white font-display text-2xl tracking-wide mb-2" data-id="element-114">
            🎾 TENIS 360™
          </div>
          <p className="text-gray-300 font-medium" data-id="element-115">
            El sistema de planificación N°1 para profesores de tenis argentinos.
          </p>
        </div>

        <div className="mb-8 italic text-gray-500 max-w-lg mx-auto" data-id="element-116">
          "Porque preparar una buena clase no debería costarte todas las noches
          de la semana."
        </div>

        <div className="flex flex-wrap justify-center gap-6 mb-10 text-sm" data-id="element-117">
          <a href="mailto:contacto@tenis360.com.ar" className="hover:text-white transition-colors" data-id="element-118">
            📧 contacto@tenis360.com.ar
          </a>
          <span className="hidden sm:inline opacity-30" data-id="element-119">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-120">
            📲 @tenis360.ar
          </a>
          <span className="hidden sm:inline opacity-30" data-id="element-121">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-122">
            🌐 www.tenis360.ar
          </a>
        </div>

        <div className="text-xs text-gray-600" data-id="element-123">
          © TENIS 360™ 2025 — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </div>
      </div>
    </footer>;
}